import _ from 'lodash';
import { MapBrowserEvent } from 'ol';
import {Options} from 'ol/interaction/Pointer.js';
import AppState from './AppState';
import EventRememberingPointerInteraction from './EventRememberingPointerInteraction';
import { Renderer } from "./Renderer";
import TrackLineFeature from './TrackLineFeature';
import TrackVectorLayer from './TrackVectorLayer';
import { TrackVectorLayerType } from './TrackVectorLayerType';

export default class HoverDistanceInteraction extends EventRememberingPointerInteraction {
    renderer: Renderer<any>;
    appState: AppState
    constructor(renderer: Renderer<any>, appState: AppState, pointerOptions?: Options) {
        super(pointerOptions);
        this.renderer = renderer
        this.appState = appState
    }

    moveEventDebounced = _.debounce((mapBrowserEvent: MapBrowserEvent<any>) => {
        const tracks = _.uniq(this.renderer.map.getFeaturesAtPixel(mapBrowserEvent.pixel, {
            hitTolerance: 10,
            layerFilter: layerSource => layerSource instanceof TrackVectorLayer && layerSource.type === TrackVectorLayerType.Track
        }).map(t => t as TrackLineFeature).map(tf => tf.track))
        const hoverDistances = _.flatten(_.sortBy(tracks, t => t.zIndex).map(t => t.getDistancesAlong(mapBrowserEvent.coordinate)))
        this.appState.hoverDistances = hoverDistances
    }, 10)

    protected handleMoveEvent(mapBrowserEvent: MapBrowserEvent<any>): void {
        this.moveEventDebounced(mapBrowserEvent)
    }
}